import pDefer from 'p-defer';
export class DeferringStorage {
    #ready = pDefer();
    #storage;
    constructor(storage, ready = pDefer()) {
        this.#storage = storage;
        this.#ready = ready;
        return new Proxy(this, {
            get: (target, prop) => {
                if (prop in target && typeof target[prop] === 'function') {
                    return (...args) => target[prop](...args);
                }
                if (typeof this.#storage[prop] === 'function') {
                    return async (...args) => {
                        await this.#ready.promise;
                        return this.#storage[prop](...args);
                    };
                }
                return this.#storage[prop];
            },
        });
    }
    namespace = (...args) => new DeferringStorage(this.#storage.namespace(...args), this.#ready);
    clear = () => this.#storage.clear();
    set = async (key, value) => {
        if (value !== undefined) {
            await this.#ready.promise;
        }
        await this.#storage.set(key, value);
    };
    delete = async (...args) => this.#storage.delete(...args);
    release = () => {
        this.#ready.resolve();
    };
}
export default function createDeferringStorage(storage) {
    return new DeferringStorage(storage);
}
